module.exports = __webpack_public_path__ + "images/wide-receiver-621f87dbb406565ddf66ed92e9a46a74.png";